import { render, staticRenderFns } from "./center.vue?vue&type=template&id=66b494f0&lang=pug&"
import script from "./center.vue?vue&type=script&lang=js&"
export * from "./center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66b494f0')) {
      api.createRecord('66b494f0', component.options)
    } else {
      api.reload('66b494f0', component.options)
    }
    module.hot.accept("./center.vue?vue&type=template&id=66b494f0&lang=pug&", function () {
      api.rerender('66b494f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/center/center.vue"
export default component.exports